import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import Snackbar from '../../common/Snackbar';
import { LoadingState } from '../../designacoes/modal/designacao/components';
import Api from '../../../service';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  position: relative;
  background: #fff;
  border-radius: 12px;
  border: 4px solid #F0F2F5;
  box-sizing: border-box;
  box-shadow: 0 12px 48px rgba(0,0,0,0.18);
  width: 95vw;
  max-width: 1100px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
  
  @media (max-width: 768px) {
    width: 98vw;
    height: 95vh;
    border-radius: 8px;
  }
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 60px 12px 32px;
  background: #F8F9FD;
  border-bottom: 1px solid #eef2f7;

  @media (max-width: 768px) {
    padding: 16px 48px 12px 16px;
    flex-direction: column;
    align-items: stretch;
  }
`;

const TopBarTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #1f2937;
  letter-spacing: -0.3px;
`;

const TopBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GridHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(180px, 2fr) 140px 120px 200px;
  padding: 16px 32px;
  background: #F8F9FD;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  text-transform: capitalize;
  letter-spacing: 0.2px;
`;

const HeaderTitleConfirmacao = styled(HeaderTitle)`
  width: 162px;
  margin-left: auto;
  justify-content: flex-start;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  z-index: 10;
  &:hover { color: #111; }
  svg { width: 20px; height: 20px; }
`;

const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
  background: #fff;
`;

const GridRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(180px, 2fr) 140px 120px 200px;
  padding: 16px 32px;
  border-bottom: 2px solid #e5e7eb;
  align-items: center;
  gap: 16px;
  transition: background 0.1s;
  &:last-child { border-bottom: none; }
  &:hover { background: #fafafa; }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 12px;
    
    & > div:nth-child(1) {
      order: 1;
    }
    & > div:nth-child(2) {
      order: 2;
      font-size: 14px;
      color: #6b7280;
    }
    & > div:nth-child(3) {
      order: 4;
      justify-self: start;
    }
    & > div:nth-child(4) {
    order: 3;
    justify-self: stretch;
  }
    & > div:nth-child(5) {
    order: 5;
    justify-self: stretch;
  }
  }
`;

const NameText = styled.div`
  font-weight: 800;
  color: #111827;
  font-size: 16px;
  margin-bottom: 4px;
  letter-spacing: -0.3px;
`;

const SubText = styled.div`
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: anywhere;
  word-break: break-word;
  max-width: 100%;
`;

const CongText = styled.div`
  color: #4b5563;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const NameCell = styled.div`
  min-width: 0;
`;

const CongregacaoCell = styled.div`
  min-width: 0;
`;

const StatusBadge = styled.span`
  background-color: ${props => props.cancelado ? '#DC2626' : '#15803d'};
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  padding: 6px 16px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  letter-spacing: 0.8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
`;

const ActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: stretch;
    
    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const ConfirmBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ reenviar }) => reenviar ? '#f59e0b' : '#25D366'};
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  transition: all 0.2s;
  white-space: nowrap;
  width: 162px;
  &:hover { 
    background-color: ${({ reenviar }) => reenviar ? '#d97706' : '#1ebc57'};
    box-shadow: 0 4px 6px rgba(0,0,0,0.12);
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.7;
  }

  &:disabled:hover {
    background-color: #9ca3af;
    box-shadow: none;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 16px;
    font-size: 14px;
  }
`;

const Footer = styled.div`
  padding: 16px 32px;
  border-top: 2px solid #e5e7eb;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px;
    align-items: stretch;
  }
`;

const FooterControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
  }
`;

const ExportWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  background: #107c41;
  color: #fff;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(16, 124, 65, 0.14);
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #0b6b36;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 9px 12px;
  }
`;

const ExportMenu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  min-width: 180px;
  overflow: hidden;
  z-index: 20;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    right: auto;
    left: 0;
  }
`;

const ExportOption = styled.button`
  width: 100%;
  border: none;
  background: #fff;
  color: #374151;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: #f3f4f6;
  }
`;

const VerTurnosButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  background: #2563EB;
  color: #fff;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.18);
  transition: background 0.2s ease, transform 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #1d4ed8;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 9px 12px;
  }
`;

const TurnoSection = styled.div`
  border-bottom: 3px solid #e5e7eb;
  &:last-child { border-bottom: none; }
`;

const TurnoHeaderButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 32px;
  background: #EFF6FF;
  border: none;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid #BFDBFE;
  transition: background 0.15s ease;

  &:hover {
    background: #E8F1FF;
  }
`;

const TurnoHeaderTitle = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #1d4ed8;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TurnoHeaderMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TurnoHeaderCount = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #2563EB;
  background: #DBEAFE;
  padding: 3px 10px;
  border-radius: 12px;
`;

const ChevronIconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563EB;
  transform: rotate(${props => props.$aberto ? '180deg' : '0deg'});
  transition: transform 0.2s ease;
`;

const TurnoGridRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(180px, 2fr) 170px;
  padding: 14px 32px;
  border-bottom: 1px solid #f3f4f6;
  align-items: center;
  gap: 16px;
  &:last-child { border-bottom: none; }
  &:hover { background: #fafafa; }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 14px 16px;
    gap: 6px;
  }
`;

const ListIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
  </svg>
);

const SelectPage = styled.select`
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 6px 12px;
  margin: 0 8px;
  font-size: 14px;
  color: #374151;
  outline: none;
  background: #fff;
  cursor: pointer;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  color: #4b5563;
  margin-left: 24px;
  
  input {
    width: 16px; 
    height: 16px;
    accent-color: #10B981;
    cursor: pointer;
    border-radius: 4px;
  }
  
  @media (max-width: 768px) {
    margin-left: 0;
    font-size: 13px;
  }
`;

const Pagination = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  span {
    font-variant-numeric: tabular-nums;
    color: #4b5563;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    font-size: 13px;
  }
`;

const PageArrow = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: color 0.1s;
  &:hover { color: #111; }
  svg { width: 22px; height: 22px; }
`;

// --- NOVOS ESTILOS PARA A CONFIRMAÇÃO INTERMEDIÁRIA DE ENVIO DE Whats ---
const ConfirmDialogOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 1200; /* Fica acima do modal principal */
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ConfirmDialogBox = styled.div`
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  
  h3 { 
    margin-top: 0; 
    color: #111827; 
    font-size: 18px;
  }
  p { 
    color: #4b5563; 
    font-size: 15px; 
    margin-bottom: 24px; 
    line-height: 1.5;
  }
`;

const DialogButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const BtnSim = styled.button`
  background-color: #10B981; /* Verde sucesso */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover { background-color: #059669; }
`;

const BtnNao = styled.button`
  background-color: #f3f4f6; /* Cinza claro */
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover { background-color: #e5e7eb; }
`;
// -------------------------------------------------------

/* Icons (Filled) */
const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
);
const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const TimeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
  </svg>
);
const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
  </svg>
);
const StatusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
    <circle cx="12" cy="12" r="4"/>
  </svg>
);
const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const LeftArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
);
const RightArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

const ExcelIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="currentColor" opacity="0.25"/>
    <path d="M14 3V8H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 10L12.5 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M12.5 10L9 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronDownIcon = ({ aberto = false }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ModalInscritos = ({ isOpen, onClose, inscritos = [], evento, onConfirmacaoEnviada }) => {
  const [snackbar, setSnackbar] = useState({ aberto: false, mensagem: '', tipo: 'success' });
  const [menuExportacaoAberto, setMenuExportacaoAberto] = useState(false);
  const [mostrarApenasAtivos, setMostrarApenasAtivos] = useState(false);
  const [confirmacaoEnviada, setConfirmacaoEnviada] = useState(new Set());
  const [visuTurnos, setVisuTurnos] = useState(false);
  const [turnosAbertos, setTurnosAbertos] = useState(new Set());
  const [inscritoAguardandoConfirmacao, setInscritoAguardandoConfirmacao] = useState(null);

  const inscritosComCongregacao = useMemo(() => {
    if (!isOpen || inscritos.length === 0) return inscritos;

    return inscritos.map((inscrito) => {
      let congregacaoNome = 'Cong. não informada';
      if (inscrito.congregacao) {
        if (typeof inscrito.congregacao === 'string') {
          congregacaoNome = inscrito.congregacao;
        } else if (typeof inscrito.congregacao === 'object' && inscrito.congregacao.nome) {
          congregacaoNome = inscrito.congregacao.nome;
        }
      }
      return { ...inscrito, congregacao: congregacaoNome };
    });
  }, [isOpen, inscritos]);

  useEffect(() => {
    if (!isOpen) {
      setMostrarApenasAtivos(false);
      setMenuExportacaoAberto(false);
      setVisuTurnos(false);
      setTurnosAbertos(new Set());
    } else {
      // Inicializa com as confirmações já registradas no banco
      const enviadas = new Set(
        inscritos
          .filter(i => i.confirmacaoEnviada)
          .map(i => String(i.inscricaoId))
      );
      setConfirmacaoEnviada(enviadas);
    }
  }, [isOpen, inscritos]);

  const alternarTurno = (turnoKey) => {
    setTurnosAbertos((prev) => {
      const proximo = new Set(prev);
      if (proximo.has(turnoKey)) {
        proximo.delete(turnoKey);
      } else {
        proximo.add(turnoKey);
      }
      return proximo;
    });
  };

  const mostrarSnackbar = (mensagem, tipo = 'warning') => {
    setSnackbar({ aberto: true, mensagem, tipo });
  };

  const fecharSnackbar = () => {
    setSnackbar({ ...snackbar, aberto: false });
  };

  const formatarDataEvento = (dataEvento) => {
    if (!dataEvento) return 'data não informada';

    try {
      return new Date(dataEvento).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    } catch (e) {
      return 'data não informada';
    }
  };

  const formatarTurnosInscrito = (turnos = []) => {
    if (!Array.isArray(turnos) || turnos.length === 0) return 'Sem turnos informados';

    return turnos
      .map((turno) => {
        const horarioInicial = turno?.horarioInicial || turno?.de || '';
        const horarioFinal = turno?.horarioFinal || turno?.ate || '';

        if (!horarioInicial && !horarioFinal) {
          return 'Turno não informado';
        }

        return `${horarioInicial || '--:--'} - ${horarioFinal || '--:--'}`;
      })
      .join(', ');
  };

  const escaparValorCsv = (valor) => {
    const texto = String(valor ?? '').replace(/"/g, '""');
    return `"${texto}"`;
  };

  // Turnos do inscrito em ordem de horário (ex.: "08:00 - 10:00, 10:00 - 12:00")
  const formatarTurnosExportacao = (turnos = []) => {
    if (!Array.isArray(turnos) || turnos.length === 0) return 'Sem turnos informados';
    const ordenados = [...turnos].sort((a, b) =>
      String(a?.horarioInicial || a?.de || '').localeCompare(String(b?.horarioInicial || b?.de || ''))
    );
    return formatarTurnosInscrito(ordenados);
  };

  const baixarArquivo = (conteudo, nomeArquivo, tipo) => {
    const blob = new Blob([conteudo], { type: tipo });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const exportarInscritos = async (formato) => {
    const inscritosAtivos = inscritosComCongregacao.filter((inscrito) => inscrito.status !== 'cancelado');

    if (!inscritosAtivos.length) {
      mostrarSnackbar('Não há inscritos para exportar.', 'warning');
      return;
    }

    const nomeEvento = evento?.nome || evento?.titulo || 'evento';
    const nomeBase = nomeEvento
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase() || 'evento';

    const linhas = inscritosAtivos.map((inscrito) => ({
      nome: inscrito.nome || 'Nome não informado',
      telefone: formatarTelefone(inscrito.telefone),
      congregacao: inscrito.congregacao || 'Cong. não informada',
      turnos: formatarTurnosExportacao(inscrito.turnos)
    }));

    const cabecalho = ['Nome', 'Telefone', 'Congregação', 'Turnos'];
    const valoresLinha = (linha) => [linha.nome, linha.telefone, linha.congregacao, linha.turnos];

    if (formato === 'csv') {
      const conteudo = [
        cabecalho.map(escaparValorCsv).join(';'),
        ...linhas.map((linha) => valoresLinha(linha).map(escaparValorCsv).join(';'))
      ].join('\n');

      baixarArquivo(`﻿${conteudo}`, `${nomeBase}-inscritos.csv`, 'text/csv;charset=utf-8;');
      mostrarSnackbar('Lista de inscritos exportada em CSV.', 'success');
      return;
    }

    try {
      // Carregada só na hora de exportar, para não pesar no carregamento do site
      const { default: writeExcelFile } = await import('write-excel-file/browser');

      const dadosPlanilha = [
        cabecalho.map((titulo) => ({ value: titulo, fontWeight: 'bold' })),
        ...linhas.map((linha) => valoresLinha(linha).map((valor) => ({ value: String(valor), wrap: true })))
      ];

      const blob = await writeExcelFile(dadosPlanilha, {
        sheet: 'Inscritos',
        columns: [{ width: 35 }, { width: 18 }, { width: 28 }, { width: 32 }],
        stickyRowsCount: 1
      }).toBlob();

      baixarArquivo(blob, `${nomeBase}-inscritos.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      mostrarSnackbar('Lista de inscritos exportada em XLSX.', 'success');
    } catch (erro) {
      console.error('[exportarInscritos] erro ao gerar XLSX:', erro);
      mostrarSnackbar('Não foi possível gerar o arquivo XLSX. Tente novamente.', 'error');
    }
  };

  const formatarMensagemEvento = ({ nome, telefone }, nomeEvento, dataEvento, localEvento, turnos) => {
    const dataStr = formatarDataEvento(dataEvento);
    const temTurnos = Array.isArray(turnos) && turnos.length > 0;
    const turnosStr = temTurnos ? formatarTurnosInscrito(turnos) : '';
    
    const linkApp = "https://tpedf.com.br/app.html"; 

    return `Olá, ${nome}!\n\nEsta é uma mensagem automática do TPE-DF sobre sua inscrição no evento *${nomeEvento}*, no dia *${dataStr}* ${localEvento ? `, no local: *${localEvento}*` : ''}.\n${turnosStr ? `\n Turno(s): ${turnosStr}\n\n` : '\n\n'}
    Por gentileza, acompanhe sua inscrição e a abertura de novos eventos pelo aplicativo do TPE-DF.\n
    *Importante:* Caso não possa participar, solicitamos gentilmente que realize o cancelamento da sua inscrição pelo aplicativo. Assim, você ajuda a oferecer a oportunidade a outros que desejam participar.\n\n
    _Respostas por WhatsApp não registram confirmação, cancelamento ou qualquer alteração na sua inscrição._\n
    Agradecemos muito sua atenção e colaboração!`;
  };

const gerarLinkWhatsAppEvento = (inscrito) => {
    const telefone = inscrito?.telefone || '';
    const numero = telefone.replace(/\D/g, ''); // Remove formatação
    
    // Validação extra: não abre se não for um número válido (mínimo de 10 ou 11 dígitos no Brasil/Portugal)
    if (!numero || numero.length < 10) {
      mostrarSnackbar('O número de telefone é inválido ou está incompleto.', 'warning');
      return; // Interrompe aqui, não muda o botão!
    }

    const msg = formatarMensagemEvento(
      inscrito, 
      evento?.nome || evento?.titulo, 
      evento?.data, 
      evento?.local, 
      inscrito?.turnos || []
    );

    // 1. Abre o WhatsApp num novo separador (aba)
    window.open(`https://wa.me/${numero}?text=${encodeURIComponent(msg)}`, '_blank');

    // 2. Abre a caixinha de confirmação no sistema em vez de guardar direto
    setInscritoAguardandoConfirmacao(inscrito);
  };

  const confirmarEnvioSucesso = async () => {
    if (!inscritoAguardandoConfirmacao) return;
    
    const inscrito = inscritoAguardandoConfirmacao;
    const eventoId = evento?._id || evento?.id;
    const inscricaoId = inscrito?.inscricaoId;

    if (inscricaoId) {
      setConfirmacaoEnviada(prev => new Set(prev).add(inscricaoId));
    }
    
    if (onConfirmacaoEnviada && inscricaoId) onConfirmacaoEnviada(inscricaoId);

    if (eventoId && inscricaoId) {
      try {
        await Api.patch('/eventos/marcarConfirmacao', { eventoId, inscricaoId });
        mostrarSnackbar('Confirmação registada com sucesso!', 'success');
      } catch (err) {
        mostrarSnackbar('Aviso: não foi possível guardar no servidor.', 'warning');
        console.error('[marcarConfirmacao] erro:', err.message, { eventoId, inscricaoId });
      }
    }
    
    // Fecha a caixinha de pergunta
    setInscritoAguardandoConfirmacao(null);
  };


  const formatarTelefone = (telefone) => {
    if (!telefone) return 'Sem telefone';
    const numero = telefone.replace(/\D/g, '');
    if (numero.length === 11) {
      return `(${numero.substring(0,2)}) ${numero.substring(2,7)}-${numero.substring(7)}`;
    }
    if (numero.length === 10) {
      return `(${numero.substring(0,2)}) ${numero.substring(2,6)}-${numero.substring(6)}`;
    }
    return telefone;
  };

  const inscritosFiltrados = mostrarApenasAtivos
    ? inscritosComCongregacao.filter((inscrito) => inscrito.status !== 'cancelado')
    : inscritosComCongregacao;

  // Agrupamento por turno: para cada turno do evento, lista inscritos ativos que o referenciam
  const turnosPorInscrito = useMemo(() => {
    const turnos = Array.isArray(evento?.turnos) ? evento.turnos : [];
    if (turnos.length === 0) return [];

    const ativos = inscritosComCongregacao.filter(i => i.status !== 'cancelado');

    return turnos.map((turno, index) => {
      const turnoId = turno._id?.toString?.() || turno._id || `${turno.horarioInicial || 'turno'}-${index}`;
      const turnoHorario = turno.horarioInicial;

      const pessoas = ativos.filter((inscrito) => {
        if (!Array.isArray(inscrito.turnos) || inscrito.turnos.length === 0) return false;
        return inscrito.turnos.some((t) => {
          const tId = t._id?.toString?.() || t._id;
          return tId === turnoId || t.horarioInicial === turnoHorario;
        });
      });

      return {
        id: turnoId,
        horario: `${turno.horarioInicial} - ${turno.horarioFinal}`,
        vagas: turno.vagas,
        vagasDisponiveis: turno.vagasDisponiveis,
        pessoas,
      };
    });
  }, [evento, inscritosComCongregacao]);

  useEffect(() => {
    if (!visuTurnos || turnosPorInscrito.length === 0) return;

    setTurnosAbertos((prev) => {
      if (prev.size > 0) return prev;
      const proximo = new Set();
      const primeiroTurno = turnosPorInscrito[0];
      if (primeiroTurno?.id) {
        proximo.add(String(primeiroTurno.id));
      }
      return proximo;
    });
  }, [visuTurnos, turnosPorInscrito]);

  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose}><CloseIcon /></CloseButton>
        <TopBar>
          <TopBarTitle>Inscritos do Evento</TopBarTitle>
          <TopBarActions>
            {/* Vagas disponíveis */}
            {(() => {
              const dataEvento = evento?.data ? (() => {
                const datePart = String(evento.data).substring(0, 10);
                const [y, m, d] = datePart.split('-').map(Number);
                return new Date(y, m - 1, d);
              })() : null;
              const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
              const encerrado = evento?.statusInscricao === 'encerrado' || (dataEvento && dataEvento < hoje);
              if (encerrado) return null;
              // Usa a soma real de vagasDisponiveis dos turnos (fonte da verdade no banco)
              // Fallback: totalVagas - inscritosAtivos (para eventos sem turnos detalhados)
              const turnos = Array.isArray(evento?.turnos) ? evento.turnos : [];
              const disponiveis = turnos.length > 0
                ? turnos.reduce((acc, t) => acc + (Number(t.vagasDisponiveis) || 0), 0)
                : Math.max((evento?.vagas ?? 0) - inscritosComCongregacao.filter(i => i.status !== 'cancelado').length, 0);
              const totalVagas = evento?.vagas ?? 0;
              if (totalVagas <= 0) return null;
              if (disponiveis <= 0) {
                return (
                  <span style={{ marginRight: 16, fontWeight: 600, color: '#DC2626', minWidth: 90, textAlign: 'right' }}>Esgotado</span>
                );
              }
              if (disponiveis === 1) {
                return (
                  <span style={{ marginRight: 16, fontWeight: 600, color: '#107c41', minWidth: 90, textAlign: 'right' }}>1 vaga disponível</span>
                );
              }
              return (
                <span style={{ marginRight: 16, fontWeight: 600, color: '#107c41', minWidth: 90, textAlign: 'right' }}>{disponiveis} vagas disponíveis</span>
              );
            })()}
            <VerTurnosButton
              type="button"
              onClick={() => setVisuTurnos((prev) => !prev)}
              title={visuTurnos ? 'Ver lista de inscritos' : 'Ver inscritos por turno'}
            >
              <ListIcon />
              <span>{visuTurnos ? 'Ver Inscritos' : 'Ver Turnos'}</span>
            </VerTurnosButton>
            <ExportWrapper>
              {menuExportacaoAberto && (
                <ExportMenu>
                  <ExportOption
                    type="button"
                    onClick={() => {
                      exportarInscritos('csv');
                      setMenuExportacaoAberto(false);
                    }}
                  >
                    <span>Baixar CSV</span>
                    <span>.csv</span>
                  </ExportOption>
                  <ExportOption
                    type="button"
                    onClick={() => {
                      exportarInscritos('xlsx');
                      setMenuExportacaoAberto(false);
                    }}
                  >
                    <span>Baixar XLSX</span>
                    <span>.xlsx</span>
                  </ExportOption>
                </ExportMenu>
              )}
              <ExportButton
                type="button"
                onClick={() => setMenuExportacaoAberto((prev) => !prev)}
                title="Exportar lista de inscritos"
              >
                <ExcelIcon />
                <span>Exportar inscritos</span>
                <ChevronDownIcon />
              </ExportButton>
            </ExportWrapper>
          </TopBarActions>
        </TopBar>
        {visuTurnos ? (
          // ===== VISÃO POR TURNO =====
          <ContentArea>
            {turnosPorInscrito.length === 0 ? (
              <div style={{ padding: '40px', textAlign: 'center', color: '#9ca3af' }}>Nenhum turno encontrado.</div>
            ) : (
              turnosPorInscrito.map((turno, index) => {
                const turnoKey = String(turno.id || `${turno.horario}-${index}`);
                const aberto = turnosAbertos.has(turnoKey);

                return (
                  <TurnoSection key={turnoKey}>
                    <TurnoHeaderButton type="button" onClick={() => alternarTurno(turnoKey)}>
                      <TurnoHeaderTitle><TimeIcon /> &nbsp;{turno.horario}</TurnoHeaderTitle>
                      <TurnoHeaderMeta>
                        <TurnoHeaderCount>{turno.pessoas.length} inscrito{turno.pessoas.length !== 1 ? 's' : ''}</TurnoHeaderCount>
                        <ChevronIconWrap $aberto={aberto}>
                          <ChevronDownIcon aberto={aberto} />
                        </ChevronIconWrap>
                      </TurnoHeaderMeta>
                    </TurnoHeaderButton>
                    {aberto && (
                      turno.pessoas.length === 0 ? (
                        <div style={{ padding: '16px 32px', color: '#9ca3af', fontSize: 14 }}>Nenhum inscrito ativo neste turno.</div>
                      ) : (
                        turno.pessoas.map((inscrito, idx) => (
                          <TurnoGridRow key={`${turnoKey}-${idx}`}>
                            <NameCell>
                              <NameText>{inscrito.nome || 'Nome não inf.'}</NameText>
                              <SubText>{formatarTelefone(inscrito.telefone)}</SubText>
                            </NameCell>
                            <CongregacaoCell>
                              <CongText>{inscrito.congregacao || 'Cong. não informada'}</CongText>
                            </CongregacaoCell>
                            <ActionCell>
                              <ConfirmBtn
                                reenviar={confirmacaoEnviada.has(String(inscrito.inscricaoId)) || inscrito.confirmacaoEnviada ? 1 : 0}
                                onClick={() => gerarLinkWhatsAppEvento(inscrito)}
                                disabled={inscrito.status === 'cancelado'}
                                title={inscrito.status === 'cancelado' ? 'Não é possível enviar confirmação para inscrição cancelada' : 'Enviar confirmação'}
                              >
                                {confirmacaoEnviada.has(String(inscrito.inscricaoId)) || inscrito.confirmacaoEnviada ? 'Enviar Novamente' : 'Enviar Confirmação'}
                              </ConfirmBtn>
                            </ActionCell>
                          </TurnoGridRow>
                        ))
                      )
                    )}
                  </TurnoSection>
                );
              })
            )}
          </ContentArea>
        ) : (
          // ===== VISÃO NORMAL (INSCRITOS) =====
          <>
        <GridHeader>
          <HeaderTitle><UserIcon /> Nome</HeaderTitle>
          <HeaderTitle><LocationIcon /> Congregação</HeaderTitle>
          <HeaderTitle><TimeIcon /> Inscrito em</HeaderTitle>
          <HeaderTitle><StatusIcon /> Status&nbsp;</HeaderTitle>
          <HeaderTitleConfirmacao><CheckIcon /> Confirmação</HeaderTitleConfirmacao>
        </GridHeader>

        <ContentArea>
          {inscritosFiltrados.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#9ca3af' }}>Nenhum inscrito encontrado.</div>
          ) : (
            inscritosFiltrados.map((inscrito, idx) => (
              <GridRow key={idx}>
                <NameCell>
                  <NameText>{inscrito.nome || 'Nome não inf.'}</NameText>
                  <SubText>{formatarTelefone(inscrito.telefone)}</SubText>
                </NameCell>
                <CongregacaoCell>
                  <CongText>{inscrito.congregacao || 'Cong. não informada'}</CongText>
                </CongregacaoCell>
                <div style={{ fontSize: 13, color: '#4b5563' }}>
                  {inscrito.inscritoEm
                    ? new Date(inscrito.inscritoEm).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                    : '—'
                  }
                </div>
                <div>
                   {inscrito.status === 'cancelado' ? (
                     <StatusBadge cancelado>CANCELADO</StatusBadge>
                   ) : (
                     <StatusBadge>ATIVO</StatusBadge>
                   )}
                </div>
                <ActionCell>
                    <ConfirmBtn
                      reenviar={confirmacaoEnviada.has(String(inscrito.inscricaoId)) || inscrito.confirmacaoEnviada ? 1 : 0}
                      onClick={() => gerarLinkWhatsAppEvento(inscrito)}
                      disabled={inscrito.status === 'cancelado'}
                      title={inscrito.status === 'cancelado' ? 'Não é possível enviar confirmação para inscrição cancelada' : 'Enviar confirmação'}
                    >
                      {confirmacaoEnviada.has(String(inscrito.inscricaoId)) || inscrito.confirmacaoEnviada ? 'Enviar Novamente' : 'Enviar Confirmação'}
                    </ConfirmBtn>
                </ActionCell>
              </GridRow>
            ))
          )}
        </ContentArea>
          </>)
        }

        <Footer>
          <FooterControls>
            <CheckboxLabel>
                <input
                  type="checkbox"
                  id="chkAtivos"
                  checked={mostrarApenasAtivos}
                  onChange={(e) => setMostrarApenasAtivos(e.target.checked)}
                />
                Mostrar apenas publicadores ativos
            </CheckboxLabel>
          </FooterControls>
        </Footer>
      </ModalContainer>

      {snackbar.aberto && (
        <Snackbar 
          mensagem={snackbar.mensagem} 
          tipo={snackbar.tipo} 
          onClose={fecharSnackbar} 
        />
      )}

      {/* NOVO: CAIXA DE CONFIRMAÇÃO DO WHATSAPP */}
      {inscritoAguardandoConfirmacao && (
        <ConfirmDialogOverlay onClick={() => setInscritoAguardandoConfirmacao(null)}>
          <ConfirmDialogBox onClick={e => e.stopPropagation()}>
            <h3>Confirmação de Envio</h3>
            <p>
              O sistema tentou abrir o WhatsApp para <strong>{inscritoAguardandoConfirmacao.nome}</strong>. <br/><br/>
              A mensagem foi enviada com sucesso?
            </p>
            <DialogButtons>
              <BtnSim onClick={confirmarEnvioSucesso}>
                Sim, registar
              </BtnSim>
              <BtnNao onClick={() => setInscritoAguardandoConfirmacao(null)}>
                Não, cancelar
              </BtnNao>
            </DialogButtons>
          </ConfirmDialogBox>
        </ConfirmDialogOverlay>
      )}

    </Overlay>
  );
};


export default ModalInscritos;
